import { ReactNode, useEffect } from 'react';
import { httpClient, useAppAuth } from '../../logic/imports';
import { DebugConsole } from './DebugConsole';

// Context providers to wrap the app in
import { UserProvider } from '../../logic/ctx/UserCtx';
import { PortfolioProvider } from '../../logic/ctx/PortfolioCtx';
import { QuotesProvider } from '../../logic/ctx/QuotesCtx';
import { DisplayProvider } from '../../logic/ctx/DisplayCtx';
import { SnaptradeProvider } from '../../logic/ctx/SnaptradeCtx';

// Inner component that uses Auth0 hook and initializes HttpClient
const InnerAppProvider = ({ children }: { children: ReactNode }) => {
    const { getAccessToken } = useAppAuth();

    useEffect(() => {
        // Initialize HttpClient's token provider so it can fetch tokens internally
        httpClient.setTokenProvider(getAccessToken);
    }, [getAccessToken]);

    const showDebugConsole = process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_DEBUG_CONSOLE === 'true';
    return (
        <>
            <UserProvider>
                <DisplayProvider>
                    <SnaptradeProvider>
                        <PortfolioProvider>
                            <QuotesProvider>
                                {children}
                            </QuotesProvider>
                        </PortfolioProvider>
                    </SnaptradeProvider>
                </DisplayProvider>
            </UserProvider>
            {showDebugConsole && <DebugConsole />}
        </>
    );
};

export const AppProvider = ({ children }: { children: ReactNode }) => {
    return <InnerAppProvider>{children}</InnerAppProvider>;
};